// services/accessLogService.js
import api from './api';

// Access Attempts
export const getAllAccessAttempts = async () => {
    try {
        const response = await api.get('/access-attempts/');
        return response.data.results;
    } catch (error) {
        console.error("Error fetching access attempts:", error);
        throw error;
    }
};

export const getAccessAttemptDetails = async (id) => {
    try {
        const response = await api.get(`/access-attempts/${id}/`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching access attempt details for id ${id}:`, error);
        throw error;
    }
};

export const getAccessAttemptsWithPagination = async ({
    page = 1,
    pageSize = 10,
    search = "",
    startDate = "",
    endDate = "",
    ordering = "-attempt_time",
}) => {
    try {
        const params = new URLSearchParams({
            page,
            page_size: pageSize,
            search,
            ordering,
        });
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);

        const response = await api.get('/access-attempts/', { params });
        return {
            results: response.data.results,
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
        };
    } catch (error) {
        console.error("Error fetching access attempts with pagination:", error);
        throw error;
    }
};

// Access Logs
export const getAllAccessLogs = async () => {
    try {
        const response = await api.get('/access-logs/');
        return response.data.results;
    } catch (error) {
        console.error("Error fetching access logs:", error);
        throw error;
    }
};

export const getAccessLogDetails = async (id) => {
    try {
        const response = await api.get(`/access-logs/${id}/`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching access log details for id ${id}:`, error);
        throw error;
    }
};

export const getAccessLogsWithPagination = async ({
    page = 1,
    pageSize = 10,
    search = "",
    startDate = "",
    endDate = "",
    ordering = "-attempt_time",
}) => {
    try {
        const params = new URLSearchParams({
            page,
            page_size: pageSize,
            search,
            ordering,
        });
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);

        const response = await api.get('/access-logs/', { params });
        return {
            results: response.data.results,
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
        };
    } catch (error) {
        console.error("Error fetching access logs with pagination:", error);
        throw error;
    }
};